module.exports = __webpack_public_path__ + "static/media/app-store-ios.123627b9.svg";